import React from "react";
import T from "prop-types";
import cn from "classnames";

import PageMessage from "2g-page-message";
import { infoTypeType } from "2g-types";

import { useMessagesGlobal } from "b2b/i18n";
import mockData from "b2b-devel/zadosti/sumar.json";

import calculateSuma from "./utils/calculateSuma";
import ZadostiGroupsAll from "./ZadostiGroupsAll";
import ZadostiGroupsTypyZdroju from "./ZadostiGroupsTypyZdroju";

function ZadostiGroupsContent({
  data,
  loading,
  loaded,
  error,
  onChange,
  value,
  showAll = false,
  type,
  messageEmpty
}) {
  const messagesGlobal = useMessagesGlobal();
  messageEmpty = messageEmpty || messagesGlobal.messageEmptyItems();
  if (loading) {
    data = mockData;
  }
  const sum = calculateSuma(data);
  return error ? (
    <PageMessage type="default" inline>
      {error}
    </PageMessage>
  ) : (!data || !data.length || !sum) && loaded ? (
    <PageMessage type="default" inline>
      {messageEmpty}
    </PageMessage>
  ) : (
    <div className={cn("b2b-ZadostiGroups", `b2b-ZadostiGroups--${type}`)}>
      <ZadostiGroupsAll
        sum={sum}
        loading={loading}
        onChange={onChange}
        showAll={showAll}
      />
      <ZadostiGroupsTypyZdroju
        data={data}
        loading={loading}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}

ZadostiGroupsContent.propTypes = {
  data: T.array,
  error: T.oneOfType([T.bool, T.string]),
  loading: T.bool,
  loaded: T.bool,
  onChange: T.func.isRequired,
  value: T.object,
  showAll: T.bool,
  type: infoTypeType.isRequired,
  messageEmpty: T.string
};

export default React.memo(ZadostiGroupsContent);
